import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const YearInput = props => {
  const {
    disabled,
    text,
    field: { touched, error, ...field },
    monthSelected,
    shouldCheckMonth,
  } = props;

  delete field.autofill;
  delete field.onUpdate;
  delete field.valid;
  delete field.invalid;
  delete field.dirty;
  delete field.pristine;
  delete field.active;
  delete field.visited;
  delete field.autofilled;

  const currentYear = new Date().getFullYear();
  const startYear = 1900;
  const years = [];
  for (let i = currentYear; i >= startYear; i--) {
    years.push(
      <option key={i} value={i}>
        {i}
      </option>
    );
  }
  const formControlClass = classnames("form-control select-input-large", {
    placeholder: !field.value,
  });
  const formGroupClass = classnames("form-group", {
    "has-error": touched && error,
  });

  const isMonthInvalid = !monthSelected || !monthSelected.value;

  const isDisabled = disabled || (shouldCheckMonth && isMonthInvalid);

  // const isDisabled = disabled || !monthSelected || !monthSelected.value;

  return (
    <div className={formGroupClass}>
      <select
        disabled={isDisabled}
        {...field}
        value={field.value || field.initialValue || ""}
        className={formControlClass}
      >
        <option value="" disabled="disabled">
          {text.year}
        </option>
        {years}
      </select>
      {touched && error && <div className="help-block">{error}</div>}
    </div>
  );
};

YearInput.propTypes = {
  disabled: PropTypes.bool,
  field: PropTypes.object.isRequired,
  text: PropTypes.object.isRequired,
};

export default YearInput;



// WEBPACK FOOTER //
// ./src/components/YearInput.js